module.exports = __webpack_public_path__ + "static/media/20x30no3.9fdd5d21.jpg";